const { localiseMarket } = require('./intl');
const markets = require('./markets');

const createGetPart = (index) => (market) => market.split('-')[index].toLowerCase();

/**
 * getLanguage extracts the language part of the market code (e.g. es-us -> es)
 *
 * @param {string} market The (Bing) market code
 * @returns {string} The canonical lowercase language
 */
exports.getLanguage = createGetPart(0);

/**
 * getCountry extracts the country part of the market code (e.g. es-us -> us)
 *
 * @param {string} market The (Bing) market code
 * @returns {string} The canonical lowercase country
 */
exports.getCountry = createGetPart(1);

/**
 * Returns the list of markets sorted according to the provided locale.
 *
 * @param {string} locale code of the language to localise the markets in
 * @returns {Array} an array of objects, same as returned by markets.js
 */
exports.getSortedLocalisedMarkets = (locale) => {
  const copy = markets.slice();
  // the "all regions" market should come at the very end, regardless of sorting order
  const all = copy.pop();

  const localise = ({ label, value, languageInLabel }) => localiseMarket(
    locale,
    value,
    languageInLabel,
  ) ?? label;

  return copy.map((market) => ({ value: market.value, label: localise(market) }))
    .sort((market1, market2) => market1.label.localeCompare(market2.label, locale))
    .concat([all]);
};
